const MAPS_DIRECTIONS_BASE = 'https://www.google.com/maps/dir/?api=1&destination=';

const isCompleteCoordinate = value => value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value));

export const getMapsDirectionsHref = ({ address, coordinates } = {}) => {
  const latitude = coordinates?.latitude;
  const longitude = coordinates?.longitude;
  const hasCoordinates = isCompleteCoordinate(latitude) && isCompleteCoordinate(longitude);
  const trimmedAddress = address?.trim?.() ?? '';

  if (hasCoordinates) {
    return `${MAPS_DIRECTIONS_BASE}${encodeURIComponent(`${Number(latitude)},${Number(longitude)}`)}`;
  }

  if (trimmedAddress) {
    return `${MAPS_DIRECTIONS_BASE}${encodeURIComponent(trimmedAddress)}`;
  }

  return null;
};
